import React from 'react';

export class Renderers {
  enterEdit: any;
  exitEdit: any;
  editFieldName: any;
  preventExit: any;
  blurTimeout: any;

  constructor(enterEdit: any, exitEdit: any, editFieldName: any) {
    this.enterEdit = enterEdit;
    this.exitEdit = exitEdit;
    this.editFieldName = editFieldName;
  }

  cellRender = (tdElement: any, cellProps: any) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem[this.editFieldName];
    const additionalProps = cellField && cellField === inEditField ?
      {
        ref: (td: any) => {
          const input = td && td.querySelector('input');
          const activeElement = document.activeElement;

          if (!input ||
            !activeElement ||
            input === activeElement ||
            !activeElement.contains(input)) {
            return;
          }

          if (input.type === 'checkbox') {
            input.focus();
          } else {
            input.select();
          }
        }
      } : {
        onClick: () => {
          this.enterEdit(dataItem, cellField);
        }
      };
    return React.cloneElement(tdElement, { 
      ...tdElement.props, 
      ...additionalProps 
    }, tdElement.props.children);
  };

  rowRender = (trElement: any) => {
    const trProps = {
      ...trElement.props,
      onBlur: () => {
        clearTimeout(this.blurTimeout);
        if (!this.preventExit) {
          this.blurTimeout = setTimeout(() => { 
            this.exitEdit(); 
          });
        }
      },
      onFocus: () => { 
        clearTimeout(this.blurTimeout); 
      }
    };
    return React.cloneElement(trElement, { 
      ...trProps 
    }, trElement.props.children);
  }
}

